import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const Arrow = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20437 0.198869L12.789 4.51989C13.0703 4.78505 13.0703 5.21495 12.789 5.48011L8.20437 9.80113C7.92303 10.0663 7.4669 10.0663 7.18556 9.80113C6.90423 9.53597 6.90423 9.10606 7.18556 8.8409L10.5404 5.67898H0.720469C0.3226 5.67898 6.39408e-05 5.37499 6.39408e-05 5C6.39408e-05 4.62501 0.3226 4.32102 0.720469 4.32102H10.5404L7.18556 1.1591C6.90423 0.893936 6.90423 0.464029 7.18556 0.198869C7.4669 -0.0662898 7.92303 -0.0662898 8.20437 0.198869Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default Arrow;
